import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';

import { CardUiModule } from './card/card-ui.module';
import { ChatBubbleComponent } from './chat-bubble/chat-bubble.component';
import { DatetimeComponent } from './datetime/datetime.component';
import { ConfirmDirective } from './directives/confirm.directive';
import { DualRangeSlinderInputComponent } from './dual-range-slider-input/dual-range-slider-input.component';
import { MealFilterComponent } from './meal-filter/meal-filter.component';
import { PasswordValidationComponent } from './password-validation/password-validation.component';
import { BloodGlucosePipe } from './pipes/blood-glucose.pipe';
import { ChangeVariablePipe } from './pipes/change-variable.pipe';
import { FLDatePipe } from './pipes/date.pipe';
import { FLNumberPipe } from './pipes/number.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SelectListInputComponent } from './select-list-input/select-list-input.component';

@NgModule({
  providers: [BloodGlucosePipe],
  imports: [
    CardUiModule,
    CommonModule,
    IonicModule,
    MarkdownModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
  ],
  declarations: [
    BloodGlucosePipe,
    ChangeVariablePipe,
    ChatBubbleComponent,
    ConfirmDirective,
    DatetimeComponent,
    DualRangeSlinderInputComponent,
    FLDatePipe,
    FLNumberPipe,
    MealFilterComponent,
    PasswordValidationComponent,
    SafeHtmlPipe,
    SelectListInputComponent,
  ],
  exports: [
    BloodGlucosePipe,
    CardUiModule,
    ChangeVariablePipe,
    ChatBubbleComponent,
    ConfirmDirective,
    DatetimeComponent,
    DualRangeSlinderInputComponent,
    FLDatePipe,
    FLNumberPipe,
    IonicModule,
    MealFilterComponent,
    PasswordValidationComponent,
    SafeHtmlPipe,
    SelectListInputComponent,
    TranslateModule,
  ],
})
export class SharedUiModule {}
